 <template>
    
  <div id="church-info">
    <!-- success alert -->
    <v-dialog
      v-model="alert"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">{{'emp._Saved_info_'|translate}}</v-card-title>

        <v-card-text>
          {{'emp._Saved_info_'|translate}}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="alert = false"
          >
            {{'general._ok_'|translate}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
      
      <v-container fluid grid-list-xl>
    <v-layout wrap align-center>
     <v-toolbar>
     <v-toolbar-title>
       <v-list-tile>
        <v-list-tile-avatar size="50">
               <img v-on:click="photoDialog" style="cursor:pointer" v-bind:src="imageUrl"/>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{form.firstName}} {{form.lastName}}</v-list-tile-title>
                <v-list-tile-sub-title>{{'members._access_code_'|translate}} : {{ this.form.accessCode }}</v-list-tile-sub-title>
              </v-list-tile-content>
       </v-list-tile>
    </v-toolbar-title>
     </v-toolbar>
      <v-card class="mb-5">
  <form @submit.prevent="validateContributionInfo">
          <v-card class="md-layout-item">
            <v-card-title>
                 <v-flex xs12 sm6>
           <label>{{'emp._money_cnt_'|translate}}</label>
                <v-radio-group
                
                name="prêt à contribuer"
                :error-messages="errors.collect('prêt à contribuer')"
                v-validate="'required'"
                v-model="form.isDonationReady"
                row>
                  <v-radio :label="$t('general._yes_')" v-on:change="showDonation = true" :value="true"></v-radio>
                <v-radio :label="$t('general._no_')"  v-on:change="showDonation = false" :value="false"></v-radio>
              {{'emp._ct_tith_'|translate}}
                </v-radio-group>
                </v-flex>
                <v-flex xs12 sm6>
           <label> </label>
                <v-radio-group
                name="contribuez à la dîme"
                :error-messages="errors.collect('contribuez à la dîme')"
                v-validate="'required'"
                v-model="form.isDimeContribution"
                row>
                  <v-radio :label="$t('general._yes_')" :value="true"></v-radio>
                <v-radio :label="$t('general._no_')" :value="false"></v-radio>
                {{'emp._ct_tith_'|translate}}
                </v-radio-group>
                </v-flex>
                      <v-flex xs12 sm6>
                <v-flex xs12 v-if="!showDonation" v-show="!showDonation">
              {{'emp._money_cnt_'|translate}}
          <v-select
          v-model="form.noDonationReason"
          name="Pas de bénévolat"
          :error-messages="errors.collect('Pas de bénévolat')"
          v-validate="'required'"
          :items="[$t('emp._not_ready_ct_'),$t('emp._do_not_work_'),$t('emp._lac_money_')]"
          solo
           ></v-select>
                </v-flex>
             <v-flex xs12 v-if="showDonation" v-show="showDonation">
               <v-text-field
            :label="$t('emp._money_')"
            type="number" min="0"
            append-icon="cash"
            v-model.number="form.donation.amount">
            
             <v-select
                :label="$t('emp._frequency_')"
             slot="append-outer"
             style="top: -20px"
              offset-y
             name="fréquence"
                :error-messages="errors.collect('fréquence')"
                v-validate="'required'"
        v-model="form.donation.frequency"
          :items="[$t('emp._Byday_'), $t('emp._Byweek_'), $t('emp._Bymonth_'),$t('emp._Byyears_')]">
        </v-select>
            </v-text-field>
            
             </v-flex>
                     </v-flex>
                    
                      <v-flex xs12 sm6>
                <v-flex xs12 v-if="!showDime" v-show="!showDime">
             {{'emp._wil_ti_chu_'|translate}}
          <v-select
          v-model="form.noDimeReason"
          name="Pas de dîme"
          :error-messages="errors.collect('Pas de dîme')"
          v-validate="'required'"
          :items="[$t('emp._not_ready_ct_'),$t('emp._do_not_work_'),$t('emp._lac_money_')]"
          solo
           ></v-select>
                </v-flex>
                 <v-card>
             <v-flex xs12 v-if="showDime" v-show="showDime">
               <v-text-field
            :label="$t('emp._how_m_times_')"
            type="number" min="0"
            append-icon="cash"
            v-model.number="form.dime.amount">
             <v-select
             label= "fréquence"
             slot="append-outer"
             style="top: -20px"
              offset-y
             name="fréquence de dîme"
                :error-messages="errors.collect('fréquence  de dîme')"
                v-validate="'required'"
        v-model="form.dime.frequency"
           :items="[$t('emp._Byday_'), $t('emp._Byweek_'), $t('emp._Bymonth_'),$t('emp._Byyears_')]">
        </v-select>
            </v-text-field>
                <!-- <v-select
             label= "Type de dîme"
             slot="append-outer"
             style="top: -20px"
              offset-y
             name="type de dîme"
                :error-messages="errors.collect('type  de dîme')"
                v-validate="'required'"
        v-model="form.dime.dimeType"
          :items="['Espèce', 'Nature']">
        </v-select> -->
           <label>{{'emp._dime_type_'|translate}} : {{form.dime.type}}</label>
                <v-radio-group v-model="form.dime.type" row>
               <v-radio :label="$t('general._Species_')" value="Espèce">{{'general._Species_'|translate}}</v-radio>
               <v-radio :label="$t('general._Nature_')"  value="Nature">{{'general._Nature_'|translate}}</v-radio>
                </v-radio-group>
            
             </v-flex>
             </v-card>
             
                     </v-flex>
                    <!-- offrande question -->
                     <v-flex xs12 sm6>
           <label>{{'emp._cont_off_'|translate}}</label>
                <v-radio-group
                v-model="form.isOffrandeContribution"
                name="Contribution d\'offrande"
                :error-messages="errors.collect('Contribution d\'offrande')"
                v-validate="'required'"
                row>
                 <v-radio :label="$t('general._yes_')"  v-on:change="showOffrande = true" :value="true"></v-radio>
                <v-radio :label="$t('general._no_')" v-on:change="showOffrande = false" :value="false"></v-radio>
                </v-radio-group>
                </v-flex>
                <!-- Grace question -->
                <v-flex xs12 sm6>
           <label>{{'emp._cnt_thanksgi_'|translate}}</label>
                <v-radio-group
                v-model="form.isGraceContribution"
                name="l'action de grâce"
                :error-messages="errors.collect('l\'action de grâce')"
                v-validate="'required'"
                row>
                <v-radio :label="$t('general._yes_')"  v-on:change="showGrace = true" :value="true"></v-radio>
                <v-radio :label="$t('general._no_')" v-on:change="showGrace = false" :value="false"></v-radio>
                </v-radio-group>
                </v-flex>

                <!-- Offrande answers -->
                     <v-flex xs12 sm6>
                     <v-card>
                         <v-card-title class="headline">{{'emp._Offering_'|translate}}</v-card-title>
             <v-flex xs12 v-if="showOffrande" v-show="showOffrande">
               <v-text-field
            :label="$t('emp._how_m_times_')"
            type="number" min="0"
            append-icon="cash"
            v-model.number="form.offrande.amount">
             <v-select
             :label="$t('emp._frequency_')"
             slot="append-outer"
             style="top: -20px"
              offset-y
             name="fréquence de d'offrande"
                :error-messages="errors.collect('fréquence  de d\'offrande')"
                v-validate="'required'"
        v-model="form.offrande.frequency"
          :items="[$t('emp._Byday_'), $t('emp._Byweek_'), $t('emp._Bymonth_'),$t('emp._Byyears_')]">
        </v-select>
            </v-text-field>
           <label>{{'emp._typ_off_'|translate}}: {{form.offrande.type}}</label>
                <v-radio-group v-model="form.offrande.type" row>
                <v-radio :label="$t('general._Species_')" value="Espèce">{{'general._Species_'|translate}}</v-radio>
               <v-radio :label="$t('general._Nature_')"  value="Nature">{{'general._Nature_'|translate}}</v-radio>
                </v-radio-group>
            
             </v-flex>
             </v-card>
             </v-flex>

             <!-- Grace answers -->
             <v-flex xs12 sm6>
                 <v-card>
                     <v-card-title class="headline">Action de Grâce</v-card-title>
             <v-flex xs12 v-if="showGrace" v-show="showGrace">
           <label>{{'emp._typ_grace_'|translate}}:</label>
                <v-radio-group
                v-model="form.graceContributionType"
                row>
                <v-radio :label="$t('general._Species_')" value="Espèce">{{'general._Species_'|translate}}</v-radio>
               <v-radio :label="$t('general._Nature_')"  value="Nature">{{'general._Nature_'|translate}}</v-radio>
                </v-radio-group>
            
             </v-flex>
             </v-card> 
             </v-flex>   
            
        </v-card-title>
        <v-card-actions>
            <v-spacer></v-spacer>
          <v-btn type="submit" color="primary">{{'general._save_'|translate}}</v-btn>
        </v-card-actions>
        </v-card>
        </form>

      </v-card>
    </v-layout>
      </v-container>
        </div>
        </template>
<script>
/* eslint-disable */
import { churches } from "@/api/churches";
import fr from "vee-validate/dist/locale/fr";
import firebase, { functions } from "firebase";
import VeeValidate, { Validator } from "vee-validate";
import { db } from "@/api/firebaseInit";
import { auth } from "@/api/firebaseInit";
Validator.localize("fr", fr);
export default {
  name: "church-info",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
        headers: [
          { text: 'Prénom et Nom', value: 'lastName' },
          { text: 'Code d\'accès', value: 'accessCode' },
          { text: 'Telephone', value: 'phone' },
        ],
      alert: false,
      
      member_id: '',
    //    form: {
    //      phone: '',
    //     accessCode: '',
    //     imageUrl: '/static/avatar/avatar.png',
    //     lastName: '',
    //     firstName: '',
    //     isDonationReady: "Non",
    //     noDonationReason: "Pas prêt à contribuer",
    //     isDimeContribution: "Non",
    //     donation: {
    //       amount: 0,
    //       frequency: "Par mois",
    //     },
    //     dime: {
    //       nombre: 0,
    //       frequency: "Par jour",
    //     },
    //     dimeType: 'Nature',
    //     isOffrandeContribution: "Non",
    //     offrandeType: 'Nature',
    //     offrande: {
    //       nombre: 0,
    //       frequency: "Par semaine",
    //     },
    //     isGraceContribution: "Non",
    //     graceContributionType: 'Nature'
    //   },
    }
  },
  created() {
    this.$validator.localize("fr", this.dictionary);
    //  this.member_id = this.$store.getters.getCurrentMemberId;
   
  },
  computed: {
     form () {
        let form = this.$store.getters.getCurrentMember;

        this.member_id = form.id
        return form
    },
    showOffrande () {
      let offrande = false
        if (this.form.isOffrandeContribution === true) {
           offrande = true
        }
        return offrande
    },
    showDonation () {
    let donation = false
        if (this.form.isDonationReady === true) {
           donation = true
        }
        return donation;
    },
      showGrace () {
      let grace = false
        if (this.form.isGraceContribution === true) {
           grace = true
        }
        return grace;
      },
      showDime () {
          let dime = false
        if (this.form.isDimeContribution === true) {
           dime = true
        }
        return dime;
      },
    imageUrl() {
      return this.$store.getters.memberPhoto;
    }
  },
  watch: {
   form (val) {
      return this.$store.commit('currentMember', val);
    }
  },
  methods: {
    fetchData() {
        db
      .collection("Census").doc(this.member_id)
      .get()
      .then((doc) => {
        this.form = {
          accessCode: doc.data().accessCode,
          phone: doc.data().phone,
          imageUrl: doc.data().imageUrl,
          firstName: doc.data().firstName,
          lastName: doc.data().lastName,
          isDonationReady: doc.data().isDonationReady,
          noDonationReason: doc.data().noDonationReason,
          noDimeReason: doc.data().noDimeReason,
          donation: doc.data().donation,
          isDimeContribution: doc.data().isDimeContribution,
          dime: doc.data().dime,
          isOffrandeContribution: doc.data().isOffrandeContribution,
          offrande: doc.data().offrande,
          isGraceContribution: doc.data().isGraceContribution,
          graceContributionType: doc.data().graceContributionType
        }
          if (doc.data().isDonationReady === null ||
          doc.data().isDonationReady === undefined
        ) {
          this.form.isDonationReady = false;
        }
      })
    },
    validateContributionInfo() {
      this.$validator.validateAll().then(result => {
        if (result) {
          


        if (this.form.isOffrandeContribution == false) {
          this.form.offrande.type = 'Espèce';
          this.form.offrande.nombre = 0;
          this.form.offrande.frequency = 'Par jour';
        } 
        if (this.form.isGraceContribution == false) {
          this.form.graceContributionType = 'Espèce';
        } 
        if (this.form.isDimeContribution == false) {
            this.form.dime.type = 'Espèce';
          this.form.dime.nombre = 0;
          this.form.dime.frequency = 'Par jour';
        } 
        if (this.form.isDonationReady === true) {
          this.form.noDonationReason = 'Pas de donations'
        } 
         if (this.form.isDimeContribution === true) {
          this.form.noDimeReason = 'Pas de donations'
        } 
        this.saveContributionInfo();
        }
      })
    },
     saveContributionInfo () {
      db.collection('Census').doc(this.member_id)
        .update({
          isDonationReady: this.form.isDonationReady,
          noDonationReason: this.form.noDonationReason,
          noDimeReason: this.form.noDimeReason,
          donation: this.form.donation,
          isDimeContribution: this.form.isDimeContribution,
          dime: this.form.dime,
          isOffrandeContribution: this.form.isOffrandeContribution,
          offrande: this.form.offrande,
          isGraceContribution: this.form.isGraceContribution,
          graceContributionType: this.form.graceContributionType
        })
        .then(() => {
           this.alert = true;
        })
        .catch(error => {
          console.error("Error adding member: ", error);
        });
    },
    photoDialog() {
      this.$router.push("/appphoto");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/form/steppers/Contribution.vue